import { useContext, useEffect, useState } from 'react';
import Message from '../../utils/Message/Message';
import { all_information, loadingShow } from '../../App';
import { MdCancel } from 'react-icons/md';
import { BsSearch } from 'react-icons/bs';
import GlobalGrid from '../../components/GlobalGrid';
import { ThemeContext } from '../../context/theme.context';
import { getBusinessLogicConfiguration } from '../../services/Dig/BusinessLogicConfiguration/BusinessLogicConfigurationServices';
var current_query: string = '';
var resultLikeQuery = '';
const assetMeterColumn = [
  { field: 'plantNo', Text: 'plant_no' },
  {
    field: 'latestReadDate',
    Text: 'latest_read_date',
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm',
  },
  { field: 'monitorAverage', Text: 'monitor_average' },
  { field: 'currentValue', Text: 'current_value' },
  { field: 'alltimeValue', Text: 'alltime_value' },
  { field: 'minReading', Text: 'min_reading' },
  { field: 'maxReading', Text: 'max_reading' },
  { field: 'maxPerDay', Text: 'max_per_day' },
  { field: 'readingsBy', Text: 'readings_by' },
  { field: 'monitorPoint', Text: 'monitor_point' },
  { field: 'updateFlag', Text: 'update_flag' },
];
var theQuerySearch = '';
const AseetMeter = () => {
  const [the_current_query, setThe_current_query] = useState('');
  const [searchText, setSearchText] = useState();
  const [signalOfLoad, setSignalOfLoad] = useState(false);
  const context = useContext(ThemeContext);
  var template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          border: '1px solid',
          borderBottomColor: 'rgb(173, 173, 193)',
          borderRightColor: 'transparent',
          borderTopColor: 'transparent',
          borderLeftColor: 'transparent',
          alignSelf: 'flex-end',
          height: 25,
          position: 'relative',
          right: 0,
          marginTop: '-12px',
        }}
      >
        <input
          style={{
            border: 'none',
            height: '20px',
            background: 'none',
          }}
          type={'text'}
          id='asset_meter'
          autoComplete='off'
          onKeyUp={inputEnterPress.bind(this)}
          onChange={(args: any) => {
            setSearchText(args.target.value);
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <MdCancel size={20} style={{}} onClick={removeSearch.bind(this)} />
        </div>
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch
            color={context.isDarkMode ? '#eaeaea' : '#292525'}
            size={20}
            style={{}}
            onClick={search.bind(this)}
          />
        </div>
      </div>
    );
  };
  const toolbarOptions: any = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    { template: template },
  ];
  useEffect(() => {
    loadingShow(true, 'process will take some time, please wait...');
    bussinesRule();
  }, []);

  const bussinesRule = () => {
    getBusinessLogicConfiguration({ org_id: all_information.company_id })
      .then((el) => {
        current_query = '';
        el.data.map((elin: any) => {
          if (
            elin.target_table === 'uw_pm_asset_meter' &&
            elin.component_name === 'Maintenance Strategies'
          ) {
            current_query += elin.condition + ' and';
          }
        });
        current_query = current_query.replaceAll('=', '€');
        current_query = current_query.substring(
          0,
          current_query.lastIndexOf('and')
        );
        buildQuery();
      })
      .catch((er) => {
        //("Can't acces business logic parameter");
        Message.error("Can't acces business logic parameter");
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
        buildQuery();
      });
  };

  const inputEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      search();
    }
  };
  const removeSearch = () => {
    if (searchText !== '') {
      $('#asset_meter').val('');
      if (resultLikeQuery !== '') {
        current_query = current_query.replace(resultLikeQuery, '');
        resultLikeQuery = '';
        buildQuery();
      }
    }
  };
  const search = () => {
    if (searchText !== '' || current_query !== '') {
      buildQuery();
    }
  };
  const buildQuery = () => {
    current_query = current_query.trimEnd();
    current_query = current_query.replace(theQuerySearch, '');
    theQuerySearch = '';
    if (searchText !== '' && searchText) {
      theQuerySearch = '$' + searchText;
      current_query = current_query + theQuerySearch;
    }
    setSignalOfLoad(true);
    setThe_current_query(current_query + ' ');
  };

  return (
    <div className='main-content-order-request'>
      <GlobalGrid
        columns={assetMeterColumn}
        height={'calc(-290px + 100vh)'}
        query={the_current_query}
        toolbarOptions={toolbarOptions}
        get_query={'asset-meter'}
        id={'asset-meter-grid'}
        isFitInCOntent={false}
        signalOfLoad={signalOfLoad}
       
      />
    </div>
  );
};

export default AseetMeter;
